export enum TextAlign {
	LEFT = "left",
	CENTER = "center",
	RIGHT = "right",
	JUSTIFY = "justify",
}

export enum HeadingLevel {
	H1 = 1,
	H2 = 2,
	H3 = 3,
	H4 = 4,
	H5 = 5,
}
